module.exports = __webpack_public_path__ + "images/marker-begraafplaats.c4400a.png";